const DELIVERY_ACCEPT = "DELIVERY_ACCEPT";
const DELIVERY_ACCEPT_SUCCESS = "DELIVERY_ACCEPT_SUCCESS";
const DELIVERY_ACCEPT_FAILURE = "DELIVERY_ACCEPT_FAILURE";
const CLEAR_DELIVERY_ACCEPT = "CLEAR_DELIVERY_ACCEPT";

const DeliveryAcceptSymbols = {
  DELIVERY_ACCEPT_SUCCESS,
  DELIVERY_ACCEPT_FAILURE,
  DELIVERY_ACCEPT,
  CLEAR_DELIVERY_ACCEPT,
};
export default DeliveryAcceptSymbols;
